import { RequiredColorPalette } from '../types';

const palette: RequiredColorPalette = {
    primary: {
        main: 'rgb(242,79,0)'
    }
};

export default palette;
